import { render, staticRenderFns } from "./PersonalAccounts.vue?vue&type=template&id=09f245a4&scoped=true&"
import script from "./PersonalAccounts.vue?vue&type=script&lang=js&"
export * from "./PersonalAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccounts.vue?vue&type=style&index=0&id=09f245a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f245a4",
  null
  
)

export default component.exports